import React, { Component } from 'react'

class SkeletonNavbar extends Component {
    render() {
        return (
            <>
                <div className='skeleton-container'>
                    <div className="skeleton-navbar-title"></div>
                    <div className="skeleton-navbar-desc"></div>
                    <div className="skeleton-navbar-desc"></div>
                </div>
                <div className='skeleton-container'>
                    <div className="skeleton-navbar-title"></div>
                    <div className="skeleton-navbar-desc"></div>
                    <div className="skeleton-navbar-desc"></div>
                </div>
                <div className='skeleton-container'>
                    <div className="skeleton-navbar-title"></div>
                    <div className="skeleton-navbar-desc"></div>
                    <div className="skeleton-navbar-desc"></div>
                </div>
            </>
        )
    }
}

export default SkeletonNavbar